module.exports = __webpack_public_path__ + "img/Bangladesh.7b8d7711.gif";